<div class="bmc-authentication">
    <bzg-message class="bmc-authentication__maintanence" [showCloseBtn]="true" [status]="'info'">
        <span class="bz-space--inline-s" *ngIf="!isMaintenanceWindowActive"> {{'AUTHENTICATION.WINDOW_MAINTENANCE_REQUIRED' | translate}} </span>
        <span class="bz-space--inline-s" *ngIf="isMaintenanceWindowActive">  {{'AUTHENTICATION.TITLE' | translate }}  </span>
        <bzg-button-secondary class="bmc-authentication__maintanence-btn" (click)="navigateWindowMaintenance()">
            <span *ngIf="!isMaintenanceWindowActive">{{'AUTHENTICATION.GO_MAINTENANCE_WINDOW' | translate }}</span>
            <span *ngIf="isMaintenanceWindowActive">{{'AUTHENTICATION.END_MAINTENANCE_WINDOW' | translate}}</span>
        </bzg-button-secondary>
    </bzg-message>

    <bzg-message *ngIf="!isValidAuthentication && isMaintenanceWindowActive && showErrorHeader" [showCloseBtn]="false" [status]="'error'">
        {{getMessage()}}
    </bzg-message>

    <div class="auth-type">
        <div class="auth-type__options">
            <auth-form-fields
                [authenticator]="selectedMethod"
                [selectedMultipleAuthenticator]="selectedMultipleAuthenticator"
                [metadata]="metadata"
                [enableNewTabAuthentication]="enableNewTabAuthentication"
                [placeholder]="initialAuthenticationType ? initialAuthenticationType : ('AUTHENTICATION.SELECT_A_TYPE' | translate)"
                [disabled]="!isMaintenanceWindowActive"
                [showDisplayName]="false"
                (typeChange)="onSelectedTypeChange($event)"
                (subtypeChange)="onSelectedSubtypeChange($event)"
                (flowChange)="onSelectedFlowChange($event)">
            </auth-form-fields>
        </div>

        <div class="auth-type__save">
            <bzg-button-primary class="bmc-authentication__auth-type__save-btn" [disabled]="!isMaintenanceWindowActive" (click)="saveAuthentication()">
                {{ "GLOBAL.SAVE" | translate }}
            </bzg-button-primary>
        </div>
    </div>

    <div class="bmc-authentication__properties" *ngIf="selectedMethod?.type !== 'Multiple' && !!selectedMetadata">
        <security-auth-list class="bmc-authentication__properties-list"
            [selectedMethod]="selectedMethod"
            [selectedMetadata]="selectedMetadata"
            [selectItemInput]="selectItem"
            (selectItem)="onSelectItem($event)">
        </security-auth-list>
        <security-auth-detail class="bmc-authentication__properties-details"
            [selectedMetadata]="selectedMetadata"
            [selectedMethod]="selectedMethod"
            [selectItem]="selectItem"
            [templateToShow]="templateToShow"
            [isDisabled]="!isMaintenanceWindowActive"
            (pendingChanges)="setPendingChanges($event)"
            (updateItem)="onUpdateItem($event)"
            (currentFileNameEmit)="setCurrentFileName($event)">
        </security-auth-detail>
    </div>
    <div class="bmc-authentication__properties" *ngIf="selectedMethod?.type === 'Multiple'">
        <multiple-auth-list class="bmc-authentication__properties-list"
            [isDisabled]="!isMaintenanceWindowActive"
            [authenticatorList]="authenticatorList"
            [selectedMultipleAuthenticator]="selectedMultipleAuthenticator"
            [selectItemInput]="selectItem"
            (createMultipleAuthenticator)="onAddMultipleAuthenticator($event)"
            (selectedAuthenticator)="onSelectMultipleAuthenticator($event)"
            (unSelectedAuthenticator)="onUnselectMultipleAuthenticator($event)"
            (selectedItem)="onSelectItem($event)"
            (deleteAuthenticators)="onDeleteMultipleAuthenticators($event)">
        </multiple-auth-list>
        <multiple-auth-detail *ngIf="addNewMultipleAuthenticator || (selectedMultipleAuthenticator && !selectItem)" class="bmc-authentication__properties-details"
            [metadata]="metadata"
            [isActiveMaintenance]="!isMaintenanceWindowActive"
            [selectedMultipleAuthenticator]="selectedMultipleAuthenticator"
            [addNewMultipleAuthenticator]="addNewMultipleAuthenticator"
            [enableNewTabAuthentication]="enableNewTabAuthentication"
            (cancelMultipleAuthenticator)="onCancelNewAuthenticator()"
            (createMultipleAuthenticator)="onCreateMultipleAuthenticator($event)">
        </multiple-auth-detail>
        <security-auth-detail *ngIf="selectedMultipleAuthenticator && selectItem" class="bmc-authentication__properties-details"
            [selectedMetadata]="selectedMetadata"
            [selectedMethod]="selectedMethod"
            [selectedMultipleAuthenticator]="selectedMultipleAuthenticator"
            [selectItem]="selectItem"
            [templateToShow]="templateToShow"
            [isDisabled]="!isMaintenanceWindowActive"
            (pendingChanges)="setPendingChanges($event)"
            (updateItem)="onUpdateItem($event)"
            (currentFileNameEmit)="setCurrentFileName($event)">
        </security-auth-detail>
        <div class="bmc-authentication__properties-message" *ngIf="!selectedMultipleAuthenticator && !addNewMultipleAuthenticator">
            {{ 'AUTHENTICATION.ADD_NEW_OR_EDIT' | translate }}
        </div>
    </div>
</div>
